import {HierarchyLevels} from "constants";

export const HIERARCHY_LEVEL_CLASSES = {
    [HierarchyLevels.CUSTOMER]: "hierarchyClass_customer",
    [HierarchyLevels.PROJECT]: "hierarchyClass_project",
    [HierarchyLevels.TASK]: "hierarchyClass_task"
}



// WEBPACK FOOTER //
// ./web/js/components/counterCPT/constants.js